import { Instagram, Mail, MapPin, Phone, Navigation } from "lucide-react";
import { BUSINESS } from "../data/content";
import { Reveal } from "./Reveal";
import { Section } from "./Section";

export const Contact = () => (
  <Section id="contact" eyebrow="Find Us" title="Up the stairs, near Ravidas Gate">
    <div className="grid gap-8 lg:grid-cols-5">
      <Reveal className="lg:col-span-3">
        <div className="card-surface h-full p-8 md:p-10">
          <ul className="space-y-8">
            <li className="flex items-start gap-4">
              <span className="mt-1 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 p-2.5 text-[#d4af37]">
                <MapPin size={18} aria-hidden="true" />
              </span>
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#8f887f]">
                  Address
                </p>
                <address
                  className="mt-2 text-base not-italic leading-relaxed text-[#f7f4ef]"
                  data-testid="contact-address"
                >
                  {BUSINESS.addressLines.map((line) => (
                    <span key={line} className="block">
                      {line}
                    </span>
                  ))}
                </address>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="mt-1 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 p-2.5 text-[#d4af37]">
                <Phone size={18} aria-hidden="true" />
              </span>
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#8f887f]">
                  Phone
                </p>
                <div className="mt-2 space-y-1.5">
                  {BUSINESS.phones.map((p) => (
                    <a
                      key={p.href}
                      href={p.href}
                      data-testid={`contact-phone-${p.href.replace(/[^0-9]/g, "")}`}
                      className="block text-base font-medium text-[#f7f4ef] transition-colors hover:text-[#d4af37]"
                    >
                      {p.label}
                    </a>
                  ))}
                </div>
                <p className="mt-2 text-sm text-[#8f887f]">
                  Call ahead for timings and table availability.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="mt-1 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 p-2.5 text-[#d4af37]">
                <Mail size={18} aria-hidden="true" />
              </span>
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#8f887f]">
                  Email
                </p>
                <a
                  href={`mailto:${BUSINESS.email}`}
                  data-testid="contact-email-link"
                  className="mt-2 block text-base font-medium text-[#f7f4ef] transition-colors hover:text-[#d4af37]"
                >
                  {BUSINESS.email}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="mt-1 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 p-2.5 text-[#d4af37]">
                <Instagram size={18} aria-hidden="true" />
              </span>
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#8f887f]">
                  Instagram
                </p>
                <a
                  href={BUSINESS.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-instagram-link"
                  className="mt-2 block text-base font-medium text-[#f7f4ef] transition-colors hover:text-[#d4af37]"
                >
                  {BUSINESS.instagramHandle}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </Reveal>
      <Reveal delay={0.12} className="lg:col-span-2">
        <div className="card-surface flex h-full flex-col justify-between overflow-hidden">
          <div className="p-8 md:p-10">
            <p className="eyebrow mb-4">Directions</p>
            <h3 className="font-display text-2xl font-semibold leading-snug text-[#f7f4ef]">
              Second floor, Swastik Plaza — look for the warm light
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-[#b5afa7]">
              We're in Lanka, a short walk from Ravidas Gate and the BHU side of town. Open the map
              for turn-by-turn directions.
            </p>
          </div>
          <div className="p-8 pt-0 md:p-10 md:pt-0">
            <a
              href={BUSINESS.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold w-full"
              data-testid="contact-directions-button"
            >
              <Navigation size={16} aria-hidden="true" /> Get Directions
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </Section>
);
